
// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

const { dark, error } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      color: dark.main,

      "&.Mui-focused": {
        color: `${dark.main} !important`,
      },

      "&.Mui-error": {
        color: `${error.main} !important`,
      },
    },
  },
};

export default formLabel;
